import React from "react";
import "./BackgroundImageCatagoryMenu.css";

const BackgroundImageCatagoryMenu = ({
  categoryName = "Category",
  categoryImages = [],
  onBack = () => {},
  onApplyImageBackground = () => {},
}) => {
  const [selectedImage, setSelectedImage] = React.useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image.id);
    // Pass both URL and full item so parent can run Unsplash tracking
    onApplyImageBackground(image.full_url || image.image, image);
  };

  return (
    <div className="background-image-catagory-controls-menu">
      <div className="catagory-detail-header">
        <button className="catagory-back-button" onClick={onBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h2 className="catagory-detail-title">{categoryName}</h2>
      </div>

      <div className="catagory-images-grid">
        {categoryImages.map((image) => (
          <div
            key={image.id}
            className={`catagory-image-item${
              selectedImage === image.id ? " selected" : ""
            }${
              image.orientation === "portrait"
                ? " catagory-image-item--portrait"
                : image.orientation === "landscape"
                  ? " catagory-image-item--landscape"
                  : ""
            }`}
            onClick={() => handleImageClick(image)}
          >
            <img
              src={image.image}
              alt={image.title || image.id}
              className="catagory-image"
              onError={(e) => {
                e.target.style.backgroundColor = "#404040";
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackgroundImageCatagoryMenu;
